import React from 'react';
import { CardElement } from '@stripe/react-stripe-js';
import LoadingSpinner from '../../ui/LoadingSpinner';

const StripeCardForm = ({ cardKey, showCardElement, onCardChange, onCardReady, disabled, saveCard }) => {
  return (
    <div style={{ marginBottom: 24, opacity: disabled ? 0.5 : 1 }}>
      <label style={{ display: 'block', fontSize: 14, fontWeight: 500, color: '#374151', marginBottom: 8 }}>
        Card Information
      </label>
      <div style={{ border: '1px solid #d1d5db', borderRadius: 6, padding: 12, backgroundColor: '#fff' }}>
        {showCardElement ? (
        <CardElement 
            key={cardKey}
            id="card-element"
            options={{
              style: {
                base: {
                  fontSize: '16px',
                  color: '#424770',
                  '::placeholder': {
                    color: '#aab7c4',
                  },
                },
                invalid: {
                  color: '#9e2146',
                  iconColor: '#9e2146',
                },
              },
            }}
            onChange={onCardChange}
            onReady={onCardReady}
        />
        ) : (
          <div style={{ padding: '8px 0', textAlign: 'center', color: '#6b7280' }}>
            <LoadingSpinner size="small" />
            <span style={{ marginLeft: 8 }}>Loading payment form...</span>
          </div>
        )}
      </div>
      <p style={{ fontSize: 12, color: '#6b7280', marginTop: 4 }}>
        Secured by Stripe.{!saveCard && ' We do not store your card details.'}
      </p>
    </div>
  );
};

export default StripeCardForm; 